<template>
    <v-layout row class="consent">
        <v-flex xs12 sm6 offset-sm3>
            <v-card>
                <v-card-text v-if="intent" >
                    <div class="title">{{ intent.ShortDescription }}</div>
                    <div class="subheading pt-3">{{ intent.Description }}</div>

                    <v-list one-line v-if="intent">
                        <v-divider></v-divider>
                        <v-list-tile v-for="Scope in intent.Scopes" :key="Scope">
                            <v-list-tile-content>
                                <v-list-tile-sub-title class="title subheading">{{ Scope }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn flat>
                                    <v-icon>info</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-dialog
                                class="pt-2"
                                persistent
                                v-model="modal"
                                lazy
                                full-width
                        >
                            <v-text-field
                                    slot="activator"
                                    label="Expiration date"
                                    prepend-icon="event"
                                    readonly
                                    :value="consent.Expiration"
                                    @input="updateExpiration"
                            ></v-text-field>
                            <v-date-picker
                                    scrollable
                                    :value="consent.Expiration"
                                    @input="updateExpiration"
                            >
                                <template scope="{ save, cancel }">
                                    <v-card-actions>
                                        <v-btn flat primary @click.native="cancel()">Cancel</v-btn>
                                        <v-btn flat primary @click.native="save()">Save</v-btn>
                                    </v-card-actions>
                                </template>
                            </v-date-picker>
                        </v-dialog>

                        <div column class="pl-3 pr-3">
                            <div class="justify title caption">
                                {{ issuer.Name }} and NowYu will use this information in accordance with their respective terms of service and privacy policies.
                            </div>
                        </div>
                    </v-list>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            flat
                            secondary
                            @click="back()"
                    >
                        Back
                    </v-btn>
                    <v-btn
                            flat
                            error
                            @click="revoke()"
                    >
                        Revoke
                    </v-btn>
                    <v-btn
                            flat
                            primary
                            @click="update()"
                    >
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Consent',
        data() {
            return {
                modal: false,
            };
        },
        computed: {
            ...mapGetters('consents', [
                'issuer',
                'intent',
                'consent',
                'redirect',
            ]),
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            updateExpiration(value) {
                this.$store.commit('consents/UPDATE_EXPIRATION', value);
                this.modal = false;
            },
            revoke() {
                this.$store
                    .dispatch('consents/REVOKE')
                    .then(this.$router.go(-1));
            },
            update() {
                this.$store
                    .dispatch('consents/ACCEPT')
                    .then(this.$router.go(-1));
            },
        },
        created() {
            this.$store.dispatch('consents/LOAD_CONSENT');
        },
    };
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// Consent.vue?80573abe